import { AbstractControl, ValidationErrors } from '@angular/forms';

export function maxYesterdayColombiaValidator(
  control: AbstractControl
): ValidationErrors | null {
  const value = control.value;

  if (!value) return null; // let required handle empty values

  const inputDate = new Date(value);

  // --- Get current date in Colombia (UTC-5) ---
  const now = new Date();

  // Convert local time to UTC
  const utcNow =
    now.getTime() + now.getTimezoneOffset() * 60 * 1000;

  // Apply Colombia offset (UTC-5)
  const colombiaNow = new Date(utcNow - 5 * 60 * 60 * 1000);

  // --- Calculate yesterday in Colombia ---
  const colombiaYesterday = new Date(colombiaNow);
  colombiaYesterday.setDate(colombiaYesterday.getDate() - 2);

  // Normalize both dates to compare only the date part
  inputDate.setHours(0, 0, 0, 0);
  colombiaYesterday.setHours(0, 0, 0, 0);

  if (inputDate > colombiaYesterday) {
    return { maxDateYesterdayColombia: true };
  }

  return null;
}

export function maxTodayColombiaValidator(
  control: AbstractControl
): ValidationErrors | null {
  const value = control.value;
  if (!value) return null;

  const inputDate = new Date(value);
  const colombiaNow = new Date(
    new Date().toLocaleString('en-US', { timeZone: 'America/Bogota' })
  );

  inputDate.setHours(0, 0, 0, 0);
  colombiaNow.setHours(0, 0, 0, 0);

  if (inputDate > colombiaNow) {
    return { maxDateTodayColombia: true };
  }

  return null;
}

export function adultValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) return null;

  const { year, month, day } = control.value;

  if (!year || !month || !day) {
    return null;
  }

  const todayInColombia = new Date(
    new Date().toLocaleString('en-US', { timeZone: 'America/Bogota' })
  );

  const birthDate = new Date(year, month - 1, day);

  let age = todayInColombia.getFullYear() - birthDate.getFullYear();
  const monthDiff = todayInColombia.getMonth() - birthDate.getMonth();

  if (
    monthDiff < 0 ||
    (monthDiff === 0 && todayInColombia.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  return age >= 18 ? null : { underAge: true };
}